import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { token, isAuthenticated } = useAuth();
    const [cartCount, setCartCount] = useState(0);
    const [wishlistCount, setWishlistCount] = useState(0);

    const API_BASE_URL = process.env.REACT_APP_API_URL;

    const fetchCounts = useCallback(async () => {
        if (!isAuthenticated || !token) {
            setCartCount(0);
            setWishlistCount(0);
            return;
        }

        try {
            const headers = { 'Authorization': `Bearer ${token}` };

            // Fetch Cart
            const cartRes = await axios.get(`${API_BASE_URL}/cart/my-cart/`, { headers });
            // More robust check: use data.items if available, or try to infer from data
            if (cartRes.data) {
                const items = cartRes.data.items || [];
                setCartCount(items.length);
                console.log('Cart count fetched:', items.length);
            }

            // Fetch Wishlist
            const wishlistRes = await axios.get(`${API_BASE_URL}/wishlist/my-wishlist/`, { headers });
            if (wishlistRes.data) {
                const items = wishlistRes.data.items || [];
                setWishlistCount(items.length);
                console.log('Wishlist count fetched:', items.length);
            }

        } catch (error) {
            console.error('Error fetching counts:', error);
            // On 401, we might want to clear counts
            if (error.response?.status === 401) {
                setCartCount(0);
                setWishlistCount(0);
            }
        }
    }, [isAuthenticated, token, API_BASE_URL]);

    useEffect(() => {
        fetchCounts();
    }, [fetchCounts]);

    return (
        <CartContext.Provider value={{ cartCount, wishlistCount, refreshCounts: fetchCounts }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
